<template>
    <div>
        <escenario-opcion-componente nombre="Uso" descripcion="Hace referencia a las condiciones de trafico peatonal y rodado que se espera que esté sometido el pavimento.">
            <template v-slot:seleccion>
                <escenario-seleccion-componente
                        :escenario="escenario"
                        campo-id="codigo"
                        campo-nombre="nombre"
                        campo-descripcion="explicacion"
                        :opciones="usos"
                        propiedad="uso"
                        descripcion="Seleccionar uso"
                        @change="seleccionarUso">
                </escenario-seleccion-componente>
            </template>
        </escenario-opcion-componente>

        <escenario-opcion-componente nombre="Tipo de soporte" descripcion="Especifica el sustrato sobre el que se asienta el pavimento urbano.">
            <template v-slot:seleccion>
                <escenario-seleccion-componente
                        :escenario="escenario"
                        campo-id="codigo"
                        campo-nombre="nombre"
                        campo-descripcion="explicacion"
                        :opciones="tipoSoportes"
                        propiedad="tipoSoporte"
                        descripcion="Seleccionar tipo soporte"
                        @change="seleccionarTipoSoporte">
                </escenario-seleccion-componente>
            </template>
        </escenario-opcion-componente>

        <escenario-opcion-componente nombre="Intensidad de tránsito" descripcion="Indica el nivel de tránsito peatonal a la que se ve sometido el pavimento. Este factor repercute en la frecuencia de mantenimiento. Más información en el apartado de Metodología.">
            <template v-slot:seleccion>
                <div class="font-italic font-weight-bold pa-2 caption" v-if="escenario && escenario.uso == null">
                    Se debe seleccionar el uso antes
                </div>
                <escenario-seleccion-componente
                        v-if="escenario && escenario.uso != null"
                        :escenario="escenario"
                        campo-id="codigo"
                        campo-nombre="nombre"
                        campo-descripcion="explicacion"
                        :opciones="intensidadesTransitoSeleccion"
                        propiedad="intensidadTransito"
                        descripcion="Seleccionar intensidad tránsito"
                        @change="seleccionarIntensidadTransito">
                </escenario-seleccion-componente>
            </template>
        </escenario-opcion-componente>

        <escenario-opcion-componente nombre="Riesgo de helada" descripcion="En aquellos casos en los que se prevean heladas será necesario indicarlos ya que afectará a las subcapas del pavimento urbano.">
            <template v-slot:seleccion>
                <escenario-seleccion-componente
                        :escenario="escenario"
                        campo-id="codigo"
                        campo-nombre="nombre"
                        :opciones="riesgoHeladas"
                        propiedad="riesgoHelada"
                        descripcion="Seleccionar riesgo helada"
                        @change="seleccionarRiesgoHelada">
                </escenario-seleccion-componente>
            </template>
        </escenario-opcion-componente>

    </div>
</template>

<script>
    import {HttpHelper} from "@/comunes/helpers/HttpHelper";
    import EscenarioOpcionComponente from "./Componentes/EscenarioOpcionComponente";
    import EscenarioSeleccionComponente from "./Componentes/EscenarioSeleccionComponente";

    export default {
        name: "EscenarioUrbano",
        model: {
            prop: 'correcto',
            event: 'change'
        },
        props: {
            escenario: {type: Object, required: true},
            correcto: {type: Boolean, default: false}
        },
        components: {
            EscenarioOpcionComponente,
            EscenarioSeleccionComponente
        },
        data: function () {
            return {
                usos: [],
                tipoSoportes: [],
                intensidadesTransitoSeleccion: [],
                intensidadesTransito: [],
                intensidadesTransitoActivadas: [],
                riesgoHeladas: []
            }
        },
        mounted() {
            Promise.all([
                this.obtenerUsos(),
                this.obtenerTipoSoportes(),
                this.obtenerIntensidadesTransito(),
                this.obtenerRiesgoHeladas(),
            ]).then(() => {
                this.emitirCorrecto(this.escenarioEsCorrecto(this.escenario));
            });
        },
        watch: {
            escenario: {
                handler(val) {
                    this.emitirCorrecto(this.escenarioEsCorrecto(val));
                },
                deep: true
            }
        },
        methods: {
            obtenerUsos() {
                return new Promise(resolve => {
                    HttpHelper.get("obra-nueva/urbano/uso")
                        .then(data => {
                            this.usos = data;
                            resolve();
                        });
                });
            },
            obtenerTipoSoportes() {
                return new Promise(resolve => {
                    HttpHelper.get("obra-nueva/urbano/tipo-soporte").then(data => {
                        this.tipoSoportes = data;
                        resolve();
                    });
                });
            },
            obtenerIntensidadesTransito() {
                return new Promise(resolve => {
                    HttpHelper.get("obra-nueva/urbano/intensidad-transito")
                        .then(data => {
                            this.intensidadesTransito = data;
                            resolve();
                            this.obtenerIntensidadesTransitoActivadas();
                        });
                });

            },
            obtenerIntensidadesTransitoActivadas() {
                return new Promise(resolve => {
                    this.intensidadesTransitoActivadas = [];

                    if (this.escenario && this.escenario.uso == null) resolve();

                    let url = "obra-nueva/urbano/intensidad-transito/por-uso/" + this.escenario.uso.codigo;
                    HttpHelper.get(url)
                        .then(data => {
                            data.forEach((type) => {
                                this.intensidadesTransitoActivadas.push(type.codigo)
                            });
                            this.intensidadesTransitoSeleccion = [];
                            this.intensidadesTransito.forEach((fm) => {
                                if (this.intensidadesTransitoActivadas.includes(fm.codigo)) {
                                    this.intensidadesTransitoSeleccion.push(fm);
                                }
                            });
                            if (this.escenario.intensidadTransito != null &&
                                !this.intensidadesTransitoActivadas.includes(this.escenario.intensidadTransito.codigo))
                                this.escenario.intensidadTransito = null;
                            resolve();
                            if (this.escenario.intensidadTransito != null)
                                this.emitirCorrecto(this.escenarioEsCorrecto(this.escenario));
                        });
                });
            },
            obtenerRiesgoHeladas() {
                return new Promise(resolve => {
                    HttpHelper.get("obra-nueva/urbano/riesgo-helada")
                        .then(data => {
                            this.riesgoHeladas = data;
                            resolve();
                        });
                });
            },
            seleccionarUso(item) {
                this.escenario.uso = item;
                this.obtenerIntensidadesTransitoActivadas();
            },
            seleccionarTipoSoporte(item) {
                this.escenario.tipoSoporte = item;
            },
            seleccionarIntensidadTransito(item) {
                if (!this.intensidadesTransitoActivadas.includes(item.codigo)) return;
                this.escenario.intensidadTransito = item;
            },
            seleccionarRiesgoHelada(item) {
                this.escenario.riesgoHelada = item;
            },
            emitirCorrecto(value) {
                this.$emit('change', value);
            },
            escenarioEsCorrecto(escenario) {
                let params = [
                    escenario.uso,
                    escenario.tipoSoporte,
                    escenario.intensidadTransito,
                    escenario.riesgoHelada
                ];

                let someNull = false;
                params.forEach((item) => {
                    if (item == null) someNull = true;
                });
                if (someNull) return false;

                if (!escenario.intensidadTransito || (this.intensidadesTransitoActivadas.length > 0 &&
                    !this.intensidadesTransitoActivadas.includes(escenario.intensidadTransito.codigo)))
                    return false;

                return true;
            },
        }
    }
</script>

<style scoped>
</style>